import { Stack } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import NewsPageNotLiveAlert from "../../NewsPageNotLiveAlert";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationEngagementSection from "./engagement/InvestorCommunicationEngagementSection";
import InvestorCommunicationSettingsSection from "./InvestorCommunicationSettingsSection";
import InvestorCommunicationStatusAlert from "./InvestorCommunicationStatusAlert";

const InvestorCommunicationSummary = () => {
  const { isNewsVisibleToInvestors } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  return (
    <Stack sx={{ flex: 1, pt: 2.5 }}>
      <Stack spacing={1.5}>
        {!isNewsVisibleToInvestors && <NewsPageNotLiveAlert />}
        <InvestorCommunicationStatusAlert />
      </Stack>
      <InvestorCommunicationEngagementSection />
      <InvestorCommunicationSettingsSection />
    </Stack>
  );
};

export default InvestorCommunicationSummary;
